import { useQuery } from '@tanstack/react-query';
import ApplicationStatuses from '../../../types/ApplicationStatuses';
import request from '../request';

const useApplicationMaintenanceStatuses = () => {
  const getApplicationStatuses = async (signal?: AbortSignal) => {
    const response = await request<ApplicationStatuses>({
      url: `${process.env.NEXT_PUBLIC_BFF_URL}/application-statuses`,
      method: 'GET',
      signal,
    });

    return response;
  };

  const res = useQuery<ApplicationStatuses, Error>({
    queryKey: ['applicationStatuses'],
    queryFn: ({ signal }) => getApplicationStatuses(signal),
    keepPreviousData: true,
    staleTime: 5000, // 1000 * 60 * 5, // 5 minutes
  });

  const tllMaintenanceStatus = res.data?.find((item) => item.service === 'TLL');
  const paypayMaintenanceStatus = res.data?.find((item) => item.service === 'PayPay');
  const ccMaintenanceStatus = res.data?.find((item) => item.service === 'CreditCard');
  return { tllMaintenanceStatus, paypayMaintenanceStatus, ccMaintenanceStatus };
};

export default useApplicationMaintenanceStatuses;
